<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" :model="setuserInfo" class="demo-form-inline"
					style="margin: 20px 0px 0px 20px;">
					<el-form-item label="商户名称" class='tiny'>
						<el-input style="width: 200px;" v-model="setuserInfo.storeName" placeholder="请输入商户名称">
						</el-input>
					</el-form-item>
					<el-form-item label="结算单号" class='tiny'>
						<el-input style="width: 200px;" v-model="setuserInfo.orderCode" placeholder="请输入结算单号">
						</el-input>
					</el-form-item>
					<!-- <el-form-item label="收款类型" class='tiny '>
						<el-select placeholder="请选择" clear>
							<el-option key="1" label="银行卡" :value="1">银行卡</el-option>
							<el-option key="2" label="支付宝" :value="2">支付宝</el-option>
							<el-option key="3" label="微信" :value="3">微信</el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="状态" class='tiny '>
						<el-select placeholder="请选择" clear v-model="setuserInfo.status">
							<el-option key="0" label="制单中" value="0">制单中</el-option>
							<el-option key="1" label="审核中" value="1">审核中</el-option>
							<el-option key="2" label="打款中" value="2">打款中</el-option>
							<el-option key="3" label="已汇款（待上传发票）" value="3">已汇款（待上传发票）</el-option>
							<el-option key="4" label="发票已上传（已寄）" value="4">发票已上传（已寄）</el-option>
							<el-option key="5" label="已完成" value="5">已完成</el-option>
							<el-option key="6" label="驳回" value="6">驳回</el-option>
							<el-option key="7" label="商家取消结算" value="7">商家取消结算</el-option>
							<el-option key="8" label="发票驳回" value="8">发票驳回</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="创建时间">
						<div class="block">
							<el-date-picker v-model="setuserInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="downloadFile">
								导出
								<a href=""></a>
							</el-button> -->
							<!-- <el-button type="primary" @click="recharge">充值</el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<div style="height:20px"></div>
		<!-- <div style="margin-left: 20px;margin-bottom: 20px;">
			<span>结算单总金额：888888.88元</span>
		</div> -->
		<el-table :data="tableData.list" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
			v-loading="loading" stripe style="width: 100%">
			<el-table-column prop="storeName" label="商户名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="orderCode" label="结算单号" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="amount" label="金额" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="status" label="状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.status == 0">制单中</div>
					<div v-if="scope.row.status == 1">审核中</div>
					<div v-if="scope.row.status == 2">打款中</div>
					<div v-if="scope.row.status == 3">已汇款（待上传发票）</div>
					<div v-if="scope.row.status == 4">发票已上传（已寄）</div>
					<div v-if="scope.row.status == 5">已完成</div>
					<div v-if="scope.row.status == 6">已驳回</div>
					<div v-if="scope.row.status == 7">商家取消结算</div>
					<div v-if="scope.row.status == 8">发票驳回</div>
				</template>
			</el-table-column>
			
			<el-table-column prop="cardUserName" label="公司名称"  align="center" :show-overflow-tooltip="true">
				
			</el-table-column>
			<el-table-column prop="cardSubbranch" label="开户银行" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="cardNo" label="银行卡号" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="address" label="凭证" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="showRecords(scope.row.id)">查 看
					</el-button>
				</template>
			</el-table-column> -->
			<el-table-column prop="address" label="查看订单" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="showOrder(scope.row.id,scope.row.status)">查看详情
					</el-button>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="address" label="查看记录" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="showRecords(scope.row.id)">查 看
					</el-button>
				</template>
			</el-table-column> -->
			<el-table-column label="操作" align="center" width="140"   fixed="right">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="lookFlow(scope.row)">查看流程</el-button>
					<!-- <el-button v-if="scope.row.status == 0" size="small" type="text"
						@click="openDocuments(scope.row.id,scope.row.storeId)">去制单</el-button> -->
					<div v-if="scope.row.status == 0">制单中</div>
					<el-button v-if="scope.row.status == 1" size="small" type="text"
						@click="shenHe(scope.row.id)">审 核</el-button>
					<!-- <el-button v-if="scope.row.status == 1" size="small " type="text"
						@click="open1(scope.row.id)">通 过</el-button>
					<el-button v-if="scope.row.status == 1" size="small" type="text"
						@click="open2(scope.row.id)">驳 回</el-button> -->
					
					<el-button v-if="scope.row.status == 2" size="small" type="text"
						@click="uploadCredentials(scope.row.id)">上传凭证</el-button>
						
					<el-button v-if="scope.row.status == 3" size="small" type="text"
						@click="uploadViewcrd(scope.row.id)">
						查看凭证</el-button>
				<!-- 	<el-button v-if="scope.row.status == 3" size="small" type="text"
						@click="uploadInvoice(scope.row.id,scope.row.orderCode,scope.row.amount,scope.row.createTime)">
						上传发票</el-button> -->
						
					<el-button v-if="scope.row.status == 4" size="small" type="text"
						@click="openDetail(scope.row.id,scope.row.orderCode,scope.row.amount,scope.row.createTime)">查看发票</el-button>
						
					<div v-if="scope.row.status == 5">已完成</div>
					<div v-if="scope.row.status == 6">已驳回</div>
					
					<div v-if="scope.row.status == 8">发票已驳回</div>
					<el-button v-if="scope.row.status == 7" size="small" type="text"
						@click="cancelSettlement(scope.row.id,7,)">取消结算</el-button>
					<!-- <el-button v-if="scope.row.status == 8" size="small" type="text"
						@click="openInvoice(scope.row.id,8)">发票已驳回</el-button> -->

				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px;" background layout="total, sizes, prev, pager, next, jumper"
			:current-page="tableData.pageNum" @current-change="pageChange" :total="tableData.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 操作记录弹窗 -->
		<el-dialog title="操作记录" :visible.sync="dialogRecords" :close-on-click-modal="false">
			 <el-timeline>
			    <el-timeline-item   timestamp="2018/4/12" placement="top">
			      <el-card>
			      <el-collapse v-model="activeName" accordion>
			        <el-collapse-item >
						 <template slot="title" style="">
							<div>66666 <span style="padding-left: 465px;">查看详情</span></div>
						</template>
			          <div>与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；</div>
			          <div>在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。</div>
			        </el-collapse-item>
			      </el-collapse>
			      </el-card>
			    </el-timeline-item>
			   
			  </el-timeline>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogRecords = false">取 消</el-button>
				<el-button type="primary" @click="dialogRecords = false">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 去制单弹窗 -->
		<!-- <el-dialog title="选择订单" :visible.sync="dialogDocuments">
			<el-table :data="gridData"  ref="table"  
			 @select="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column property="orderCode" label="订单号"  align="center"></el-table-column>
				<el-table-column property="settlementPrice" label="金额"  align="center"></el-table-column>
				<el-table-column property="sendTime" label="时间" align="center"></el-table-column>
			</el-table>
			<el-pagination style="margin: 20px;" background layout="total, sizes, prev, pager, next, jumper">
			</el-pagination>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogDocuments = false">取 消</el-button>
				<el-button type="primary" @click="ordeSure">确 定</el-button>
			</div>
		</el-dialog> -->
		
		<!-- 审核弹窗 -->
		<el-dialog title="结算单详情" :visible.sync="dialogExamine" width="70%" :close-on-click-modal="false">
			<el-form :model="form" :inline="true">
				<div>
					<el-form-item label="结算单号：" class="odText odLeft">
						<span>{{setInfo.orderCode}}</span>
					</el-form-item>
					<el-form-item label="订单金额：" class="odText">
							<span>￥</span><span>{{setInfo.amount}}</span>
					</el-form-item>
				</div>
				<div>
					<el-form-item label="商户名称：" class="odText odLeft">
						<span>{{setInfo.storeName}}</span>
					</el-form-item>
					<el-form-item label="商户编码：" class="odText">
						<span>{{setInfo.code}}</span>
					</el-form-item>
				</div>
				<div>
					<el-form-item label="公司名称：" class="odText odLeft">
						<span>{{setInfo.cardUserName}}</span>
					</el-form-item>
					<el-form-item label="开户银行：" class="odText">
							<span>{{setInfo.cardSubbranch}}</span>
					</el-form-item>
				</div>
				<div>
					<el-form-item label="收款账号：" class="odText odLeft">
						<span>{{setInfo.cardNo}}</span>
					</el-form-item>
					<el-form-item label="创建时间：" class="odText">
							<span>{{setInfo.createTime}}</span>
					</el-form-item>
				</div>
				
			</el-form>
			<div style="height:20px"></div>
			<el-table :data="setInfo.list"  height="250"  ref="table" border  empty-text="暂无订单">
				<el-table-column property="orderCode" label="订单号"  align="center" width="200px"></el-table-column>
				<el-table-column property="cOrderCode" label="三方订单号"  align="center" width="300px"></el-table-column>
				<el-table-column property="amount" label="金额"  align="center"></el-table-column>
				<el-table-column property="sendTime" label="时间" align="center"></el-table-column>
			</el-table>
			<el-pagination style="margin: 20px;" background layout="total, sizes, prev, pager, next, jumper"
			:current-page="setInfo.pageNum" @current-change="pageChange2" :total="setInfo.total"
			 @size-change="handleSizeChange2">
			</el-pagination>
			<div slot="footer" class="dialog-footer">
				<el-button  @click="open3">取消</el-button>
				<el-button type="danger" @click="open2(setInfo.id)">驳 回</el-button>
				<el-button type="primary" @click="open1(setInfo.id)">通 过</el-button>
			</div>
		</el-dialog>
		
		<!-- 结算单详情弹窗 -->
		<el-dialog title="结算单详情" :visible.sync="dialogOrdeeDatail" @close="page1.pageNum=1" width="80%"
		:close-on-click-modal="false">
			<el-form :model="form" :inline="true">
				<div>
					<el-form-item label="结算单号：" class="odText odLeft">
						<span>{{setInfo.orderCode}}</span>
					</el-form-item>
					<el-form-item label="订单金额：" class="odText">
							<span>￥</span><span>{{setInfo.amount}}</span>
					</el-form-item>
				</div>
				<div>
					<el-form-item label="商户名称：" class="odText odLeft">
						<span>{{setInfo.storeName}}</span>
					</el-form-item>
					<el-form-item label="商户编码：" class="odText">
							<span>{{setInfo.code}}</span>
					</el-form-item>
				</div>
				<div>
					<el-form-item label="公司名称：" class="odText odLeft">
						<span>{{setInfo.cardUserName}}</span>
					</el-form-item>
					<el-form-item label="开户银行：" class="odText">
							<span>{{setInfo.cardSubbranch}}</span>
					</el-form-item>
				</div>
				<div>
					<el-form-item label="收款账号：" class="odText odLeft">
						<span>{{setInfo.cardNo}}</span>
					</el-form-item>
					<el-form-item label="创建时间：" class="odText">
							<span>{{setInfo.createTime}}</span>
					</el-form-item>
				</div>
			</el-form>
			<div style="height:20px"></div>
			<el-table :data="setInfo.list"  height="250"  ref="table" border  empty-text="暂无订单">
				<el-table-column property="orderCode" label="订单号"  align="center" width="200px"></el-table-column>
				<el-table-column property="cOrderCode" label="三方订单号"  align="center" width="300px"></el-table-column>
				<el-table-column property="amount" label="金额"  align="center"></el-table-column>
				<el-table-column property="sendTime" label="时间" align="center"></el-table-column>

				<el-table-column  property="expressCode" label="操作" align="center">
					<template  slot-scope="scope">
						<span @click="showContent(scope.row)" style="color: green;border-bottom: 1px solid green;cursor:pointer;margin-right:20px">订单详情</span>
						<span @click="lookexp(scope.row.expressCode)" style="color: green;border-bottom: 1px solid green;cursor:pointer;">查看物流</span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination style="margin: 20px;" background layout="total, sizes, prev, pager, next, jumper"
			:current-page="setInfo.pageNum" @current-change="pageChange1" :total="setInfo.total" 
			@size-change="handleSizeChange1">
			</el-pagination>
			<el-button type="primary" @click="downloadFile">导 出</el-button>
			<!-- <div slot="footer" class="dialog-footer">
				<el-button @click="dialogOrdeeDatail = false">取 消</el-button>
				<el-button type="primary" @click="ordeSure">确 定</el-button>
				
				
			</div> -->
		</el-dialog>
		
		
		<!-- 上传凭证 -->
		<el-dialog title="上传凭证" :visible.sync="dialogCredentials" :close-on-click-modal="false">
			<el-form :model="formCredent">
				<el-form-item label="上传图片：" >
						<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview2"
							:on-remove="handleRemove2" :file-list="fileList" :show-file-list="true"
							:on-success="onSuccess2">
							<i class="el-icon-plus"></i>
						</el-upload>
				</el-form-item>
				<el-form-item label="备注:">
				    <el-input type="textarea" v-model="formCredent.remok" placeholder="请输入备注(选填)" style="width: 400px;"></el-input>
				  </el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogCredentials = false">取 消</el-button>
				<el-button type="primary" @click="upCredential">确 定</el-button>
			</div>
		</el-dialog>
		
		<!-- 查看凭证 -->
		<el-dialog
		  title="查看凭证"
		  center
		  :visible.sync="dialogViewcreals">
		  <el-form :model="from3">
			  <el-form-item label="发票照片：" >
				  <!-- <el-carousel-item v-for="(item,index) in cImages" :key="index" style="height: 500px;"> -->
				  <el-carousel indicator-position="outside" style="width: 750px;height: 500px;">
				  	<el-carousel-item  v-for="(item , index) in credenImage2" :key="index"  style="width: 700px;height: auto;">
				  		<img :src="item" style="width: 100%; height: auto;" />
				  	</el-carousel-item>
				  </el-carousel>
			  </el-form-item>
			 <el-form-item v-if="from3.credMemo" label="备注:">
			      <el-input type="textarea" style="width: 300px;" v-model="from3.credMemo"></el-input>
				</el-form-item>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogViewcreals = false">取 消</el-button>
		    <el-button type="primary" @click="dialogViewcreals = false">确 定</el-button>
		  </span>
		</el-dialog>
		
		<!-- 上传发票 -->
		<el-dialog title="上传发票" :visible.sync="dialoguploadInvoice" :close-on-click-modal="false">
			<el-form :model="form">
				<el-form-item label="结算单号：" >
					<span>{{orderId}}</span>
				</el-form-item>
				<el-form-item label="订单金额：" >
						<span>￥</span><span>{{Amount}}</span>
				</el-form-item>
				<el-form-item label="创建时间：" >
						<span>{{CreatTime}}</span>
				</el-form-item>
				<el-form-item label="上传图片：" >
						<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
							:on-remove="handleRemove" :file-list="fileList" :show-file-list="true"
							:on-success="onSuccess">
							<i class="el-icon-plus"></i>
						</el-upload>
				</el-form-item>
				<el-form-item label="备注:">
				    <el-input type="textarea" v-model="form.remok" placeholder="请输入备注" style="width: 400px;"></el-input>
				  </el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialoguploadInvoice = false">取 消</el-button>
				<el-button type="primary" @click="uploadImg">确 定</el-button>
			</div>
		</el-dialog>
		
		<!-- 查看详情 -->
		<el-dialog title="发票详情" :visible.sync="dialogDetail" :close-on-click-modal="false">
			<el-dialog
			  title="发票驳回"
			   append-to-body
			  :visible.sync="dialogInvoiceBohui">
			  <el-form :model="from2">
				  <el-form-item label="驳回原因:">
				      <el-input type="textarea" style="width: 300px;" v-model="from2.desc"></el-input>
					</el-form-item>
			  </el-form>
			  <span slot="footer" class="dialog-footer">
			    <el-button @click="dialogInvoiceBohui = false">取 消</el-button>
			    <el-button type="primary" @click="sureInvoiceBohui">确 定</el-button>
			  </span>
			</el-dialog>
			<el-form :model="form4">
				<el-form-item label="结算单号：" >
					<span>{{orderId}}</span>
				</el-form-item>
				<el-form-item label="订单金额：" >
						<span>￥</span><span>{{Amount}}</span>
				</el-form-item>
				<el-form-item label="创建时间：" >
						<span>{{CreatTime}}</span>
				</el-form-item>
				<el-form-item label="图片详情：" >
						<el-carousel indicator-position="outside" style="width: 650px;height: 340px;">
							<el-carousel-item  v-for="(item , index) in goodsImages2" :key="index"  style="width: 650px;height: 340px;">
								<img :src="item" style="width: 100%; height: 100%;" />
							</el-carousel-item>
						</el-carousel>
				</el-form-item>
				<el-form-item label="备注:">
				    <el-input type="textarea" v-model="form4.remok" placeholder="请输入备注" style="width: 400px;"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button  type="danger" @click="rejectDatil(bohuId)">驳回</el-button>
				<el-button type="primary" @click="sureDetail">通过</el-button>
			</div>
		</el-dialog>
		<el-dialog style="float:rigin;overflow-y: scroll;" title="物流详情" :visible.sync="ExpDialog" width="60%"
			:close-on-click-modal="false">
		
				<el-steps :active="wudetail.length" align-center direction="vertical">
				  <el-step v-for="(item,index) in wudetail" :key="index"  :title="item.context" :description="item.ftime"></el-step>
				</el-steps>
		
			
		
		</el-dialog>
		<!-- 驳回 -->
		<el-dialog
		  title="驳回"
		  :visible.sync="dialogBohui">
		  <el-form :model="from2">
			  <el-form-item label="驳回原因:">
			      <el-input type="textarea" v-model="form.desc"></el-input>
			    </el-form-item>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogBohui = false">取 消</el-button>
		    <el-button type="primary" @click="dialogBohui = false">确 定</el-button>
		  </span>
		</el-dialog>
		
		<!-- 发票驳回 -->
		

		<!-- 订单详情对话框 -->
		<el-dialog title="订单详情" :visible.sync="dialogVisible" width="60%" :before-close="handleClose"
			:close-on-click-modal="false">
			<div>
				<div style="margin:10px 0 ;">
					<strong>商品详情</strong>&nbsp;&nbsp;&nbsp;&nbsp;
				</div>

				<div class="orderList">
					<div class="orderxq" v-for="(item,index) in orderInfo.goodsList" :key="index">
						<div>
							<img :src="item.images.split(',')[0]" alt="" style="width:100px;height:100px;">
							<div style="margin-top:10px" v-if="item.brandName">
								品牌: {{ item.brandName }}
							</div>
						</div>
						<div class="orderxq-txt">
							<p>商品名称：{{item.goodsName}}</p>
							<p >供应商名称：{{orderInfo.sStoreName?orderInfo.sStoreName:'无'}}</p>
							<p>购买数量：{{item.num}} {{ item.unitName}}</p>
							<p v-if="storeType==1 || storeType==3">供应成本价：{{item.costPrice}}</p>
							<p v-if="storeType==2 || storeType==3">协议价：{{item.agreementPrice}}</p>
							<!-- <p>零售价：{{item.price}}</p> -->
						</div>
					</div>
				</div>
				<el-form v-model="orderInfo" label-position="left" inline class="demo-table-expand">
					<el-form-item label="订单号">
						<span>{{orderInfo.orderCode?orderInfo.orderCode:'暂无'}}</span>
					</el-form-item>
				<!-- 	<el-form-item label="支付类型">
						<span v-if="orderInfo.payType=='wx'">微信支付</span>
						<span v-if="orderInfo.payType=='integral'">积分抵扣-{{orderInfo.coinName}}</span>
						<span v-if="orderInfo.payType=='wx_plural'">微信积分混合支付</span>
						<span v-if="orderInfo.payType=='huiJu_Ali_Pay'">汇聚支付宝支付</span>
						<span v-if="orderInfo.payType=='huiJu_Quick_Pay'">汇聚快捷支付</span>
					</el-form-item> -->
					<!-- <el-form-item label="所属区域">
						<span>{{orderInfo.province}}{{orderInfo.city}}{{orderInfo.area}}</span>
					</el-form-item> -->
					<el-form-item label="订单状态">
						<span v-if="orderInfo.status==0">待扣款</span>
						<span v-if="orderInfo.status==1">待发货</span>
						<span v-if="orderInfo.status==2">待收货</span>
						<span v-if="orderInfo.status==3">已完成</span>
						<span v-if="orderInfo.status==4">退款申请</span>
						<span v-if="orderInfo.status==5">已退款</span>
						<span v-if="orderInfo.status==6">部分退款</span>
						<span v-if="orderInfo.status==7">已失效</span>
						<span v-if="orderInfo.status==8">驳回</span>
						<span v-if="orderInfo.status==9">取消</span>
					</el-form-item>
					<!-- <el-form-item label="订单总价">
						<span>{{orderInfo.totalPrice?"￥"+orderInfo.totalPrice:'暂无'}}</span>
					</el-form-item> -->
					<el-form-item label="协议总价"  v-if="storeType==3||storeType==2" >
						<span>{{orderInfo.agreementPrice?"￥"+orderInfo.agreementPrice:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="供应结算总价"  v-if="storeType==3||storeType==1" >
						<span>{{orderInfo.settlementPrice?"￥"+orderInfo.settlementPrice:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="收货人">
						<span>{{orderInfo.name?orderInfo.name:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="联系电话">
						<span>{{orderInfo.phone?orderInfo.phone:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="详细地址">
						<span>{{orderInfo.province}}{{orderInfo.city}}{{orderInfo.area}}{{orderInfo.address}}</span>
					</el-form-item>
					<el-form-item label="购买时间">
						<span>{{orderInfo.createTime?orderInfo.createTime:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="快递公司">
						<span>{{orderInfo.expressName?orderInfo.expressName:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="快递单号">
						<span>{{orderInfo.expressCode?orderInfo.expressCode:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="发货人">
						<span>{{orderInfo.sendOpUser?orderInfo.sendOpUser:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="发货时间">
						<span>{{orderInfo.sendTime?orderInfo.sendTime:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="确认收货时间">
						<span>{{orderInfo.completeTime?orderInfo.completeTime:'暂未确认'}}</span>
					</el-form-item>
					<el-form-item label="查看物流" v-if="orderInfo.status==2||orderInfo.status==3">
						<!-- @click="lookexp(scope.row.expressCode)" -->
						<span @click="lookexp(orderInfo.expressCode)" style="color: green;border-bottom: 1px solid green;cursor:pointer;">立即查看</span>
					</el-form-item>
					<el-form-item label="备注">
						<span>{{orderInfo.remark?orderInfo.remark:'暂无'}}</span>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
				<el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
			</span>
		</el-dialog>

		<!-- 查看流程 -->
		<el-dialog title=" 查看流程" :visible.sync="dialogFlow" :close-on-click-modal="false">
			<el-table :data="flowTableData" ref="table" border>
				<el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
				<el-table-column property="statusText" label="状态" align="center"></el-table-column>
				<el-table-column property="systemDocuments" label="凭证" align="center">
					<template slot-scope="scope">
						<!-- <img :src="(scope.row.systemDocuments || '').split(',')[0]" style="width:100px;height:auto;"> -->
						<el-button  size="small" type="text" v-if="scope.row.systemDocuments!=null"
						@click="uploadViewcrdAA(scope.row)">
						查看</el-button>
					</template>
				</el-table-column>
				<el-table-column property="operBy" label="操作人"  align="center"></el-table-column>
				<el-table-column property="createTime" label="时间" align="center"></el-table-column>
				<el-table-column property="memo" label="描述" align="center">
					<template slot-scope="scope">
						<span>{{ scope.row.memo?scope.row.memo:'暂无' }}</span>
					</template>
				</el-table-column>
			</el-table>
			<!-- <el-pagination style="margin: 20px;" background layout="total, sizes, prev, pager, next, jumper"
				:current-page="flowTableData.pageNum" @current-change="flowpageChange" :total="flowTableData.total"
				@size-change="flowhandleSizeChange">
			</el-pagination> -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogFlow = false">关闭</el-button>
			</span>
		</el-dialog>

		<!-- 查看流程里看图片 -->
		<el-dialog title="查看凭证" center :visible.sync="dialogViewcrealsAA" :close-on-click-modal="false"
		>
			<el-form >
				<el-form-item label="照片：">
					<el-carousel indicator-position="outside" style="width: 900px;height: 600px;">
						<el-carousel-item v-for="(item , index) in credenImageAA" :key="index" indicator-position
							style="width: 850px;height: auto;">
							<img :src="item" style="width: 100%; height: auto;" />
						</el-carousel-item>
					</el-carousel>
				</el-form-item>
				<!-- <el-form-item v-if="from3.credMemo" label="备注:">
					<el-input type="textarea" style="width: 300px;" v-model="from3.credMemo"></el-input>
				</el-form-item> -->
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogViewcrealsAA = false">取 消</el-button>
				<!-- <el-button type="primary" @click="dialogViewcreals = false">确 定</el-button> -->
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();
	export default {
		data() {
			return {
				dialogDocuments: false, //选择订单弹窗
				dialogOrdeeDatail:false, //结算单详情弹窗
				dialoguploadInvoice:false, //上传图片弹窗
				dialogBohui:false,  //驳回弹窗
				dialogInvoiceBohui:false, //发票驳回
				dialogRecords:false, //操作记录弹窗
				dialogExamine:false, //审核弹窗
				dialogCredentials:false,//上传凭证弹窗
				dialogViewcreals:false, //查看凭证弹窗
				dialogDetail:false, //查看发票详情弹窗
				tableData: {}, //结算单数据列表
				ExpDialog:false,
				wudetail:[{}],
				// pageStart: 1, //起始页
				// pageCount: 10, //默认20条
				page: {
					pageNum: 1,
					pageSize: 10
				},
				page1: {
					pageNum: 1,
					pageSize: 10
				},
				page2: {
					pageNum: 1,
					pageSize: 10
				},
				page3: {
					pageNum: 1,
					pageSize: 10
				},
				loading: false,
				setuserInfo: {},
				gridData: [], //订单数据列表
				form: {
				  remok:''
				},
				from2:{
					desc: ''
				},
				formCredent:{
					remok:''
				},
				from3:{
					credMemo:'',
				},
				form4:{
					remok:''
				},
				httpUrl: urls,
				dialogImageUrl: '',
				dialogVisible: false, //订单详情
				fileList: [],
				goodsImages: [], //发票照片数组
				goodsImages2:[], //查看发票照片数组
				credenImage:[], //上传凭证照片数组
				credenImage2:[], //查看凭证照片数组
				orderId:'',
				Amount:'',
				CreatTime:'',
				setId:'',
				activeName: '1',
				orderList:[], //选择订单列表
				RecordsList:[],//操作记录列表
				radio: '',
				exmId:'',//审核传的id
				credenId:'',//上传凭证传的id
				bohuId:'', //发票驳回传的id
				setInfo:{}, //结算单详情信息
				ids:'',
				idss:'',
				orderInfo:{}, //订单详情
				storeType:'',
				dialogFlow: false, //查看流程弹窗
				flowTableData: [],
				flowpage:{
					pageNum: 1,
					pageSize: 10
				},
				// flowloading:true,
				dialogViewcrealsAA: false, //查看流程里看图片
				credenImageAA: [], //查看流程凭证照片数组
			}
		},
		created() {
			this.$api.getUserInfo().then((res) => {
				res.data=JSON.parse(this.$decrypt(res.data)).data
				if (res.state == 'success') {
					this.storeType = res.data.user.storeType
					// console.log(this.storeType);
				}
			})
			// console.log(11111);
			this.setTableList()
			// this.setOrderlist()
		},
		methods: {
			lookFlow(item){ //查看流程
				this.dialogFlow = true;
				// console.log('点击表格---',item)
				// swId

				// this.flowpage
				// let datet={
				// 	swId:item.id
				// }
				this.$api.lookFlowList(item.id).then(res => {
					// console.log('流程表格数据--',res);
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.flowTableData = res.data
						this.flowloading = false
					}
				})
			},
			// 订单详情查询
			showContent(e) {
				// console.log('点击行--',e)
				let data = {
					id: e.orderId,
					areaId: e.areaId,
					provinceId: e.provinceId,
					cityId: e.cityId
				}
				this.$api.findOrderInfo(this.$encrypt(data)).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log('商品详情--',res.data[0])
					if (res.state == 'success') {
						this.orderInfo = res.data[0]
						this.dialogVisible = true
					} else {
						this.$message.error(res.message)
					}
				})
			},
			handleClose() { //订单详情关闭
				this.dialogVisible = false
			},
			setTableList() {
				// console.log('参数11---',this.setuserInfo)
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,

					startTime: this.setuserInfo.timer ? this.setuserInfo.timer[0] : "",
					endTime: this.setuserInfo.timer ? this.setuserInfo.timer[1] : "",
					storeName: this.setuserInfo.storeName,
					orderCode: this.setuserInfo.orderCode,
					status: this.setuserInfo.status
					// ...this.setuserInfo
				}
				// console.log('参数---',data)
				this.$api.setmentListpc(this.$encrypt(data)).then(res => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						
						this.tableData = res.data
						this.loading = false
					}
				})
			},
			showloadFile(res) {
				if (!res) {
					return
				}
				const link = document.createElement('a');
				let blob = new Blob([res], {
					type: 'application/vnd.ms-excel'
				});
				link.style.display = 'none';
				link.href = URL.createObjectURL(blob);
				link.setAttribute('download', '结算单' + '.xls');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
			pageChange(data) {
				this.page.pageNum = data
				this.setTableList()
			},
			pageChange1(data) {
				this.page1.pageNum = data
				this.xqlist()
			},
			pageChange2(data) {
				this.page2.pageNum = data
				this.shlist()
			},
			handleSizeChange2(val) {
				this.page2.pageSize = val
				this.shlist()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.setTableList()
			},
			handleSizeChange1(val) {
				this.page1.pageSize = val
				this.xqlist()
			},
			// 打开选择订单弹窗
			showRecords(id){
				// console.log(id);
				this.$api.setRecords(id).then(res=>{
					// console.log(res);
				})
				this.dialogRecords = true
			},
			handleSelectionChange(selection, row) {
			  // console.log('手动勾选数据行', selection, row)
			  // 判断当前行是否选中
			  const selected = selection.some(item => item === row)  // 是取消选择还是选中
			  if (selected) { // 选择
				this.orderList.push(row)
			  } else { // 取消选择
				var finalArr = this.orderList.filter((item) => { 
				  return item.id !== row.id
				})
				this.orderList = finalArr
			  }
			//   console.log('更改选择后', this.orderList)
			},
			ordeSure(){
		
				this.$api.setAddList(this.$encrypt(this.orderList)).then(res=>{
					// console.log(res);
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogDocuments = false
					}
				})
			},
			
			// 打开选择订单弹窗
			openDocuments() {
				this.dialogDocuments = true
				this.$api.setOrderlist(this.pageCount + '/' + this.pageStart).then(res => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if(res.state == 'success'){
						this.gridData = res.data.list
					}
				})
			},
			
			// 审核弹窗
			shenHe(id){
				this.idss=id
				this.dialogExamine = true
				this.shlist()
			},
			shlist(id){
				let data = {
					pageNum: this.page2.pageNum,
					pageSize: this.page2.pageSize,
					id:this.idss
				}
				this.$api.setOrderdetauil(this.$encrypt(data)).then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
					
					if(res.state == "success"){
						this.setInfo = res.data
					}
				})
			},
			// 打开结算单详情弹窗
			showOrder(id){
				this.ids=id
				this.dialogOrdeeDatail = true
				this.xqlist()
			},
			xqlist(){
				let data = {
					pageNum: this.page1.pageNum,
					pageSize: this.page1.pageSize,
					id:this.ids
				}
				this.$api.setOrderdetauil(this.$encrypt(data)).then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
						// console.log(res);
					if(res.state == "success"){
						this.setInfo = res.data
					}
				})
			},
			lookexp(id){
				// console.log(id);
				
				this.$api.lookExpress(id).then(res=>{
					
					if(res.state=='success'){
					this.ExpDialog=true
						this.wudetail=JSON.parse(res.data.detail).reverse()
					}else{
						this.$message.error(res.message);
					}
				})
			},
			// 通过审核
			open1(id){
				// console.log(id);
				this.exmId = id
				this.$confirm('是否通过审核？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success'
				}).then(() => {
					let data = {
						swId:this.exmId,
						status:2
					}
					this.$api.setExmaine(this.$encrypt(data)).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							// this.dialogDetail = false
							this.dialogExamine = false
							this.setTableList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
				
			},
			// 驳回审核
			open2(id){
				// console.log(id);
				this.exmId = id
				this.$confirm('是否驳回该结算单？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					let data = {
						swId:this.exmId,
						status:6
					}
					this.$api.setExmaine(this.$encrypt(data)).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							// this.dialogDetail = false
							this.dialogExamine = false
							this.setTableList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			// 取消审核
			open3(){
				this.dialogExamine = false
			},
			//审核弹窗确定按钮
			// examineSure(){
			// 	console.log(this.radio);
			// 	if(this.radio == '1'){
			// 		let data = {
			// 			swId:this.exmId,
			// 			status:2
			// 		}
			// 		this.$api.setExmaine(data).then(res=>{
			// 			console.log(res);
			// 			if(res.state = 'success'){
			// 				this.$message({
			// 					message: res.message,
			// 					type: 'success'
			// 				});
			// 				this.dialogExamine = false
			// 				this.setTableList()
			// 			}
			// 		})
			// 	}else if(this.radio == '2'){
			// 		let data = {
			// 			swId:this.exmId,
			// 			status:6
			// 		}
			// 		this.$api.setExmaine(data).then(res=>{
			// 			console.log(res);
			// 			if(res.state = 'success'){
			// 				this.$message({
			// 					message: res.message,
			// 					type: 'error'
			// 				});
			// 				this.dialogExamine = false
			// 				this.setTableList()
			// 			}
			// 		})
			// 	}
			// },
			// 上传凭证图片
			uploadCredentials(id){
				// console.log(id);
				this.credenId = id
				this.dialogCredentials=true
			},
			onSuccess2(response, file, fileList){
				this.credenImage.push(response.message);
				// console.log("asda",response,this.credenImage)
			},
			// handleRemove2(file, fileList) {
			// 	console.log(file, fileList);
			// },
			handleRemove2(file, fileList) {
				if (file.response) {
					this.credenImage.remove(file.response.message);
				}
				this.credenImage.remove(file.url);
			},
			handlePictureCardPreview2(){
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			// 上传凭证确定方法
			upCredential(){
				// console.log(this.formCredent.remok);
				if(!this.credenImage[0]){
					this.$message({
						message: '请上传图片',
						type: 'warning'
					});
				}
				let data = {
					swId:this.credenId,
					systemDocuments:this.credenImage.join(','),
					memo:this.formCredent.remok,
					status:3
				}
				this.$api.setExmaine(this.$encrypt(data)).then(res=>{
					// console.log(res);
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogCredentials = false
						this.setTableList()
					}else{
						this.$message({
							message: res.message,
							type: 'warning'
						});
					}
				})
			},
			uploadViewcrdAA(e){ //查看流程的图片查看
				this.credenImageAA = [];
				this.dialogViewcrealsAA = true
				this.credenImageAA = (e.systemDocuments || '').split(',')
				// console.log('查看流程的图片查看---',this.credenImageAA)
			},
			//查看凭证
			uploadViewcrd(id){
				this.dialogViewcreals = true
				this.$api.setCrendatail(id).then(res=>{
					// console.log(res);
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if(res.state == 'success'){
						this.credenImage2 = res.data.systemDocuments.split(',')
						this.from3.credMemo = res.data.memo
					}
					// console.log(this.credenImage2);
				})
			},
			
			uploadInvoice(id,orderId,amount,createTime){  //打开上传发票弹窗
				// console.log(id,amount);
				this.setId = id
				this.orderId = orderId
				this.Amount = amount
				this.CreatTime = createTime
				this.dialoguploadInvoice = true
			},
			
			// 打开查看发票详情弹窗
			openDetail(id,orderId,amount,createTime){
				// console.log(id,orderId,amount,createTime);
				this.orderId = orderId
				this.Amount = amount
				this.CreatTime = createTime
				this.dialogDetail = true
				this.$api.setDatail(id).then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log(res);
					if(res.state == 'success'){
						this.goodsImages2 = res.data.systemDocuments.split(',')
						this.form4.remok = res.data.memo
						this.bohuId = res.data.swId
					}
				})
			},
			// 发票审核通过按钮
			sureDetail(){
				// console.log(this.bohuId);
				this.$confirm('确认发票详情是否正确？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success'
				}).then(() => {
					let data = {
						swId:this.bohuId,
						status:5
					}
					this.$api.setExmaine(this.$encrypt(data)).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.dialogDetail = false
							this.setTableList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			// 发票审核驳回按钮
			rejectDatil(id){
				// console.log(id);
				this.dialogInvoiceBohui = true
			},
			//驳回确认
			sureInvoiceBohui(id){
				// console.log(id);
				if(!this.from2.desc){
					this.$message({
						message: '请填写驳回原因',
						type: 'warning'
					});
					return
				}
				let data = {
					swId:this.bohuId,
					memo:this.from2.desc ,
					status:8
				}
				this.$api.setExmaine(this.$encrypt(data)).then(res=>{
					// console.log(res);
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogInvoiceBohui = false
						this.dialogDetail = false
						this.setTableList()
					}
				})
			},
			// 打开驳回弹窗
			queryIntegralWithdrawal(){
				this.dialogBohui = true
			},
			// 打开发票驳回弹窗
			openInvoice(){
				this.dialogInvoiceBohui = true
			},
			onSuccess(response, file, fileList) {
				// console.log(res)
				this.goodsImages.push(response.message);
				// console.log("asda",response,this.goodsImages)
			},
			// handleRemove(file, fileList) {
			// 	console.log(file, fileList);
			// },
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			beforeAvatarUpload(file) {
				// const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
				  this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			uploadImg(){  //上传图片的方法
			// console.log(this.form.remok);
			if(!this.form.remok){
				this.$message({
					message: '请填写备注',
					type: 'warning'
				});
			}
			if(!this.goodsImages[0]){
				this.$message({
					message: '请上传图片',
					type: 'warning'
				});
			}
			let data = {
				swId:this.setId,
				systemDocuments:this.goodsImages.join(','),
				memo:this.form.remok
			}
				this.$api.uploadImg(this.$encrypt(data)).then(res=>{
					// console.log(res);
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialoguploadInvoice = false
						this.setTableList()
					}
				})
			},
			search() { //查询
				// console.log(this.setuserInfo);
				this.loading = true
				this.setTableList()
			},
			empty() { //清空
				this.setuserInfo = {}
			},
			downloadFile() { // 导出
				// console.log(this.setInfo);
				this.$api.Jsdexport(this.setInfo.id).then((res) => {
					// console.log(res.data)
					this.showloadFile(res.data)
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.odText{
		margin-right: 60px;
	}
	.odLeft{
		width: 350px;
		// border: 1px solid saddlebrown;
	}
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 178px;
	    height: 178px;
	    line-height: 178px;
	    text-align: center;
	  }
	  .avatar {
	    width: 178px;
	    height: 178px;
	    display: block;
	  }
	  /deep/.el-collapse{
		  border-top:none
	  }
	  /deep/ .el-collapse-item__header{
		  border-bottom:none
	  }
	  /deep/ .el-textarea__inner{
		  height: 100px;
	  }
	  /deep/ .el-dialog__body{
		  padding-bottom: 10px;
	  }
	  /deep/ .el-form-item{
		margin-bottom: 0px;
	}

	.orderList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		// border: 1px solid saddlebrown;
	}
	.orderxq {
		display: flex;
		width: 50%;
		align-items: flex-start;
		align-content: flex-start;
		// border: 1px solid red;
	}
	.orderxq-txt{
		margin-left:20px;
		p{
			margin: 0;
			margin-bottom: 10px;
		}
	}
</style>